import { instance } from "../apiclient";
import { CreateOrderObject, CreateGiftOrderObject } from "./Utilities";
import store from "../../store/index";
import { ReplaceAll } from "../helpers/stringHelper";
import uuid from "uuid/v1";

export class DefaultPaymentHandler {
  MakePayment(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 }
  ) {
    var orderModel;
    if (isGift) {
      orderModel = CreateGiftOrderObject(
        store.state.giftShoppingCart,
        store.getters.giftCartValue,
        user,
        resturant,
        card,
        guid,
        orderInfo
      );
    } else {
      let priceItem = {
        totalPrice: store.getters.getTotalPrice,
        subTotalPrice: store.getters.cartValue,
        totalTax: store.getters.totaltax,
        freeOrderItems: store.getters.getFreeOrderItems,
        discountTax: store.getters.discountTax,
        discountExcludingTax: store.getters.discountExcludingTax
      };
      orderModel = CreateOrderObject(
        store.state.shoppingCart,
        priceItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        guestUserId,
        store.getters.priceTriggerOutcomes
      );
    }
    const trackingOrderModel = {
      TrackingOrder: {
        ...orderModel,
        AppliedCouponCodes: AppliedCouponList,
        RoomNumber: orderInfo.roomNumber,
        Tables: [{ Name: orderInfo.tableNumber }],
        ...loyalty
      }
    };
    if (user.IsGuest) {
      Object.defineProperty(trackingOrderModel, "GuestUser", {
        value: {
          FirstName: user.FirstName,
          LastName: user.LastName,
          Email: user.Email,
          CreateUserForGuest: user.CreateUserForGuest
        },
        enumerable: true
      });
    }
    if (card && Object.keys(card).length != 0) {
      if (isGift || (!card.exclude && store.getters.getTotalPrice > 0)) {
        let ExpiryYear = card.expYear;
        if (card.expYear.length != 4) {
          ExpiryYear = "20" + card.expYear.trim();
        }
        Object.defineProperty(trackingOrderModel, "Card", {
          value: {
            CardHolder: card.holder,
            CardNumber: ReplaceAll(card.number, " ", ""),
            ExpiryYear: ExpiryYear,
            ExpiryMonth: card.expMonth.trim(),
            Cvv: card.cvc,
            ForceUseSandboxPayment:
              process.env.NODE_ENV === "production"
                ? "false"
                : true
          },
          enumerable: true
        });
      }
    }
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  Reorder(orderItem) {
    var order = Object.assign({}, orderItem);
    var guid = uuid();
    order.OnlineOrderStatus = 1;
    order.CreatedOn = new Date().toUTCString();
    order.InvoiceNumber = "";
    order.OnlineOrderStatusDescription = "";
    order.PaymentTransactions = [
      {
        Amount: order.PaymentTransactions[0].Amount
      }
    ];
    order.ScheduledTime = new Date().toUTCString();
    delete order.IsTimeOut;
    for (var tempItem of order.OrderItems) {
      tempItem.CreatedOn = new Date().toUTCString();
      tempItem.UDID = uuid();
      for (var tempExtra of tempItem.OrderExtras) {
        tempExtra.UDID = uuid();
      }
    }
    order.UDID = guid;
    const trackingOrderModel = {
      TrackingOrder: {
        ...order
      }
    };
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }
}
